import cx from 'classnames';
import { Media } from '../presentational/media';
import Skeleton from '../presentational/skeleton';
import { VideoDockedComponent } from '../ads/videoComponent';

export default function SkeletonProfileSection(props: any) {
  const isEmptyContactInfo =
    !props.characterCustomizations ||
    (!props.characterCustomizations.bnet_battletag &&
      !props.characterCustomizations.discord_profile &&
      !props.characterCustomizations.twitter_profile);

  const isShowStreamTwitch = !!props.stream;
  const isShowDocked = !props.currentFeatures.no_ads && !props.stream && props.currentFeatures.ac_docking_character;

  return (
    <section className="rio-p-horizontal-mobi--x-small">
      <div className="slds-grid slds-grid--vertical-stretch slds-wrap slds-large-nowrap">
        <div
          className={cx(
            'slds-col',
            'slds-grow',
            'slds-max-small-size--1-of-1',
            'slds-max-medium-size--1-of-1',
            'rio-p-right-mobi--none',
            'rio-p-right-tablet--xx-small',
            'slds-p-right--x-small',
            'rio-m-top-mobi--large',
            'rio-m-bottom-mobi--large',
            'slds-m-bottom--x-large',
            'rio-p-right-tablet--none'
          )}
        >
          <div className="about-container">
            <Skeleton height={42} />
            <Skeleton variant="item" height={275} animate />
            <Skeleton height={42} />
          </div>
        </div>
        <div
          className={cx(
            'slds-col',
            'slds-grow-none',
            'slds-max-small-size--1-of-1',
            'slds-max-medium-size--1-of-1',
            'slds-max-large-size--1-of-1',
            'rio-p-left-mobi--none',
            'rio-p-left-tablet--xx-small',
            'slds-p-left--x-small',
            'rio-m-bottom-mobi--large',
            'slds-m-bottom--x-large',
            'rio-p-left-tablet--none',
            {
              'rio-m-bottom-mobi--none': !props.stream && isEmptyContactInfo,
              'rio-m-bottom-xs-mobi--none': isEmptyContactInfo,
              'rio-max-large--d-flex': isShowStreamTwitch || isShowDocked
            }
          )}
        >
          {isShowDocked && (
            <Media greaterThan="sm">
              <div className="slds-m-bottom--small">
                <VideoDockedComponent
                  id="rio-docked-video"
                  inStreamPlacement={true}
                  slot="stream"
                  width={400}
                  height={225}
                  trackVisibility={true}
                  className="slds-m-bottom--medium"
                />
              </div>
            </Media>
          )}

          {/* {isShowStreamTwitch && (
						<Media greaterThan="sm">
							<div className="slds-m-bottom--small">
								<Skeleton width={400} height={225} animate />
							</div>
						</Media>
					)} */}
          {/* {!isShowStreamTwitch && isShowDocked && (
						<Media greaterThan="sm">
							<div className="slds-m-bottom--medium">
								<Skeleton width={400} height={225} animate />
							</div>
						</Media>
					)} */}
          <div
            className={cx('rio-m-top-mobi--small', {
              'rio-m-top-mobi--none': isEmptyContactInfo,
              'slds-grow': isShowStreamTwitch || isShowDocked,
              'rio-p-left-tablet--x-small': isShowStreamTwitch || isShowDocked
            })}
          >
            <div
              style={{ minWidth: 300 }}
              className={cx('rio-m-bottom-mobi--large', { 'rio-hidden--small': isEmptyContactInfo })}
            >
              {isShowStreamTwitch || isShowDocked ? (
                <Skeleton width="unset" height={225} style={{ minWidth: 300 }} animate />
              ) : (
                <Skeleton width="unset" height={225} style={{ minWidth: 300 }} animate />
              )}
            </div>
            {props.canShowQueueButton && (
              <section className="slds-large-show slds-text-align--center text-white slds-m-top--small">
                <div className="slds-grid slds-size--1-of-1 slds-grid--align-center">
                  <Skeleton width={130} height={40} style={{ borderRadius: '4px', margin: 12 }} animate />
                </div>
                <div className="slds-grid slds-size--1-of-1 slds-grid--align-center">
                  <Skeleton width={158} height={20} style={{ borderRadius: '4px' }} animate />
                </div>
              </section>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
